export const API_URL = "https://valerotexasopen.com/benefit-for-children/api";
export const CFWORKER_API_URL = "https://vto-worker-api.qnm.workers.dev"; // http://localhost:8787 https://vto-worker-api.qnm.workers.dev

export const RECAPTCHA_KEY = "6LfkuhkUAAAAAMtYySi117tvZtrs0fzC2RzCVrEE";

export const AUTHNET_SCRIPT = "https://js.authorize.net/v1/Accept.js";
export const AUTHNET_LOGINID = "9Mm8bL3ev";
export const AUTHNET_PUBKEY =
	"9U38t44Ansu8r9LLky7D9E2yggJNSMz54SPY7rHRw5xMXp2K5zG22FJDcSE6mTLm";

/* Authnet / Production
  export const AUTHNET_SCRIPT = "https://js.authorize.net/v1/Accept.js";
  export const AUTHNET_LOGINID = "9Mm8bL3ev";
  export const AUTHNET_PUBKEY = "9U38t44Ansu8r9LLky7D9E2yggJNSMz54SPY7rHRw5xMXp2K5zG22FJDcSE6mTLm";
*/

/* Authnet / Sandbox 
  export const AUTHNET_SCRIPT = "https://jstest.authorize.net/v1/Accept.js";
  export const AUTHNET_LOGINID = "34fhtk8Be8C7";
  export const AUTHNET_PUBKEY =
    "44S79RZmJ3jf7teah5u8wp95WCcRHX2rJ3S6a48Hx3t6w6jarbaRQFnGEaLVcLd6";
*/

export function createMarkup(html) {
	return { __html: html };
}

export function isFieldError(array, val) {
	return array.includes(val);
}

export function scroll() {
	return window.jQuery("html, body").animate(
		{
			scrollTop:
				window.jQuery("#bfc-root").offset().top -
				window.jQuery("#header").height(),
		},
		200,
	);
}

export function fmtBytes(bytes, decimals = 0) {
	if (bytes === 0) return "0 Bytes";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

const isBrowser = () => typeof window !== "undefined";

export const getValFromLS = (key, useSessionStorage = false) => {
	if (useSessionStorage) {
		return isBrowser() && window.sessionStorage.getItem(key)
			? window.sessionStorage.getItem(key)
			: undefined;
	} else {
		return isBrowser() && window.localStorage.getItem(key)
			? window.localStorage.getItem(key)
			: undefined;
	}
};

export const setValToLS = (key, val, useSessionStorage = false) => {
	if (isBrowser() && val) {
		useSessionStorage
			? window.sessionStorage.setItem(key, val)
			: window.localStorage.setItem(key, val);
	} else {
		useSessionStorage
			? window.sessionStorage.removeItem(key)
			: window.localStorage.removeItem(key);
	}
	return true;
};

export const isCardType = (str) => {
	if (str) {
		str = str.replace(/\s/g, "").replace(/-/g, "");
		const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
		const mast = /^(?:5[1-5][0-9]{14})$/;
		const amex = /^(?:3[47][0-9]{13})$/;
		const disc = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
		if (str.match(visa)) {
			return "visa";
		} else if (str.match(mast)) {
			return "mastercard";
		} else if (str.match(amex)) {
			return "amex";
		} else if (str.match(disc)) {
			return "discover";
		} else {
			return "no";
		}
	} else {
		return "no";
	}
};

export function fmtCurrency(int, cents = 2) {
	const amt = int;
	return `${amt.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: cents,
		maximumFractionDigits: cents,
	})}`;
}

export function isTopSponsor(id) {
	if (
		id === "emcor2026" ||
		id === "valero2026" ||
		id === "exclusivesponsor" ||
		id === "executivesponsor" ||
		id === "platinumsponsor" ||
		id === "palladiumsponsor"
	) {
		return true;
	} else {
		return false;
	}
}

export function isAllowedHotel(id) {
	if (
		id === "partnersponsor" ||
		id === "premiersponsor" ||
		id === "diamondgoldsponsor" ||
		id === "diamondsponsor" ||
		id === "goldsponsor" ||
		id === "silversponsor" ||
		id === "recognitionsponsor" ||
		id === "donation"
	) {
		return false;
	} else {
		return true;
	}
}

export function isAllowedOffSiteHotel(id) {
	if (
		id === "partnersponsor" ||
		id === "premiersponsor" ||
		id === "diamondgoldsponsor" ||
		id === "diamondsponsor" ||
		id === "goldsponsor" ||
		id === "silversponsor"
	) {
		return true;
	} else {
		return false;
	}
}

export function consoilidatedGuests(golf, sporting, welcome, gift) {
	let newArray = [];

	golf.forEach((item) => {
		const index = newArray.findIndex((el) => el.guestId === item.guestId);

		if (index !== -1) {
			newArray[index].golf = item.status;
		} else {
			newArray.push({
				golf: item.status,
				sporting: 0,
				welcome: 0,
				gift: 0,
				...item,
			});
		}
	});

	sporting.forEach((item) => {
		const index = newArray.findIndex((el) => el.guestId === item.guestId);

		if (index !== -1) {
			newArray[index].sporting = item.status;
		} else {
			newArray.push({
				golf: 0,
				sporting: item.status,
				welcome: 0,
				gift: 0,
				...item,
			});
		}
	});

	welcome.forEach((item) => {
		const index = newArray.findIndex((el) => el.guestId === item.guestId);

		if (index !== -1) {
			newArray[index].welcome = item.status;
		} else {
			newArray.push({
				golf: 0,
				sporting: 0,
				welcome: item.status,
				gift: 0,
				...item,
			});
		}
	});

	gift.forEach((item) => {
		const index = newArray.findIndex((el) => el.guestId === item.guestId);

		if (index !== -1) {
			newArray[index].gift = item.status;
		} else {
			newArray.push({
				golf: 0,
				sporting: 0,
				welcome: 0,
				gift: item.status,
				...item,
			});
		}
	});

	return newArray;
}

export function createScaleArray(q) {
	return [
		{
			name: `${q}`,
			val: "1",
			label: "1",
		},
		{
			name: `${q}`,
			val: "2",
			label: "2",
		},
		{
			name: `${q}`,
			val: "3",
			label: "3",
		},
		{
			name: `${q}`,
			val: "4",
			label: "4",
		},
		{
			name: `${q}`,
			val: "5",
			label: "5",
		},
	];
}
